import React, { useState } from 'react';
import { Button, Input } from 'antd';
import { PaymentMethod } from '~/types/Payment';

const OtherPaymentTab = ({
  onSubmit,
}: {
  onSubmit: (params: { method: PaymentMethod; description: string }) => void;
}) => {
  const [description, setDescription] = useState<string>('');

  const onOk = () => {
    if (!description) {
      return;
    }
    onSubmit({ method: PaymentMethod.Other, description });
  };

  return (
    <div className="d-flex">
      <Input
        placeholder="Deskripsi"
        onChange={(event) => setDescription(event.target.value)}
      />
      <Button onClick={onOk} disabled={!Boolean(description)} type="primary">
        OK
      </Button>
    </div>
  );
};

export default OtherPaymentTab;
